/* Size gate for the product page.

   Shopify always resolves a product to a variant, so the theme arrives with a
   size already selected and Add to cart live. That reads as "size L is chosen"
   to a shopper who has chosen nothing, and it is the usual cause of a wrong
   size being ordered.

   This holds the submit button at "Choose size" and suppresses the selected
   size's underline until a size is actually picked. A view that already names
   a variant is left alone: that is a deep link from a card on the home page or
   a collection, where the shopper did pick the size.

   It does NOT uncheck the radios. An earlier version did, and that left the
   theme with no variant to resolve: it rendered its "this combination is not
   available" notice, hid the price and swapped the button to Notify me. The
   variant stays selected for Shopify's benefit; only its appearance and the
   button are held back. */
(function () {
  'use strict';

  var UNCHOSEN_CLASS = 'size-unchosen';

  /* Set the moment a size is picked anywhere on the page. Gating is
     re-attempted after load, because the sticky bar is cloned from the main
     purchase block and does not exist on the first pass - but once there is a
     real choice, nothing may re-gate it. A preselected size is not a choice:
     Shopify ships one checked. Only this flag distinguishes the two. */
  var chosen = false;

  /* The page carries two purchase blocks - the one in the product info and the
     sticky bar that appears on scroll - each with its own copy of the radios.
     The sticky copy prefixes every input id with "floated-", which is the only
     reliable way to tell the two sets apart: the radios are rendered outside
     the <form> they drive, so neither set is reachable by form association. */
  function sizeInputs(floated) {
    return Array.prototype.filter.call(
      document.querySelectorAll('.product-parameters input[type="radio"]'),
      function (input) {
        var isFloated = input.id.indexOf('floated-') === 0;
        if (isFloated !== floated) return false;

        /* Colour swatches and size chips are both radios here; the swatch
           carries .color-swatch on its label, the size chip does not. */
        var label = document.querySelector('label[for="' + input.id + '"]');
        return label && !label.classList.contains('color-swatch');
      }
    );
  }

  function setLabel(button, text) {
    var span = button.querySelector('span');
    if (span) span.textContent = text;
    else button.textContent = text;
  }

  function release(button, cartLabel, chooseLabel) {
    chosen = true;
    document.documentElement.classList.remove(UNCHOSEN_CLASS);

    button.removeAttribute('disabled');
    button.removeAttribute('data-size-gated');
    setLabel(button, cartLabel || chooseLabel);

    /* From here the theme's own variant handling owns the button: it
       re-renders the form on each change and will set Sold out itself. */
  }

  function gate(button) {
    if (chosen) return;

    /* Sold out already owns the button; leave that message alone. */
    if (button.hasAttribute('disabled')) return;

    var chooseLabel = button.dataset.chooseSizeLabel;
    var cartLabel = button.dataset.addToCartLabel;
    if (!chooseLabel) return;

    var inputs = sizeInputs(!!button.closest('.floated-form'));
    /* Nothing to choose - a one-size product stays a normal Add to cart. */
    if (inputs.length < 2) return;

    document.documentElement.classList.add(UNCHOSEN_CLASS);

    button.setAttribute('disabled', 'disabled');
    button.setAttribute('data-size-gated', 'true');
    setLabel(button, chooseLabel);

    function onPick() {
      release(button, cartLabel, chooseLabel);
    }

    inputs.forEach(function (input) {
      /* change covers picking a different size. click on the label covers
         picking the one Shopify had already selected, which fires no change
         event but is still the shopper making the choice. */
      input.addEventListener('change', onPick, { once: true });

      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label) label.addEventListener('click', onPick, { once: true });
    });
  }

  function run() {
    /* A deep link that names the variant means the size was chosen upstream. */
    if (new URLSearchParams(window.location.search).has('variant')) return;

    document.querySelectorAll('.product-form__submit').forEach(gate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  /* <floated-form> ships empty and is filled by cloning the main purchase
     block, so its button and radios do not exist on the first pass. gate()
     skips anything already gated or already chosen, so re-running is safe. */
  window.addEventListener('load', function () {
    run();
    window.setTimeout(run, 1200);
  });
})();
